import Bloc from './Bloc.js';
import Types from './Types.js';

export default class ExtremumEnemy extends Bloc {

	constructor (src, ctx) {

		super("extremumenemy", src, ctx);
		this.f = (src, ins) => {
			const enemies = src.master.liveEnemies;

			if (!enemies.length) return [undefined, undefined];

			const lowest = enemies.reduce((min, e) => e.hp < min.hp ? e : min);
			const highest = enemies.reduce((max, e) => e.hp > max.hp ? e : max);

			return [lowest, highest];
		};
		this.types = [];
	}
}
